import { api } from '@/core/api';

const URL = '/api/purchaseservice';

export const getInitFilters = (excludeArea = true) =>
  api.get(`${URL}/initfilters?excludeArea=${excludeArea}`);
export const getCatalogs = (params) => api.get(`${URL}/catalogs`, { params });
export const get = (params) => api.get(URL, { params });
export const getById = (id, summarized = false) =>
  summarized ? api.get(`${URL}/${id}/summarized`) : api.get(`${URL}/${id}`);
export const save = (payload) => api.post(`${URL}`, payload);
export const remove = (id) => api.delete(`${URL}/${id}`);
export const changeStatus = (id, payload) =>
  api.patch(`${URL}/${id}/status`, payload);

export const saveSupportingDocument = (payload) =>
  api.post(`${URL}/supporting-documents`, payload);
export const deleteSupportingDocument = (id) =>
  api.delete(`${URL}/supporting-documents/${id}`);

export const saveSignedDocument = (payload) =>
  api.post(`${URL}/signed-document`, payload);

export const saveMechanism = (id, mechanims) =>
  api.put(`${URL}/${id}/mechanism/${mechanims}`);

export const getByNumber = (id, number) =>
  api.get(`${URL}/${id}/bynumber/${number}`);

export const getDeterminationCategoryTypes = () =>
  api.get(`${URL}/determinationtypes`);

export const getLogHistory = (id) => api.get(`${URL}/loghistory/${id}`);

export const getAnnouncementByNumber = (id, number) =>
  api.get(`${URL}/${id}/announcement/${number}`);

export const withContractAnnouncement = (params) =>
  api.get(`api/providers/withcontractannouncement`, { params });

export const getPrograms = (typeId) => api.get(`${URL}/programs/${typeId}`);

export const getCompanyContracts = (params) =>
  api.get(`api/providers/company/contracts`, { params });

export const determinate = (id, payload) =>
  api.post(`${URL}/${id}/determinate`, payload);

export const getDeterminationDocumentTypes = (id) =>
  api.get(`${URL}/${id}/determination/documents-types`);

export const getDeterminationDocuments = (id, params) =>
  api.get(`${URL}/${id}/determination/documents`, { params });

export const getPreviousBudgetEntries = (params) =>
  api.get(`${URL}/budget/previous-entries`, { params });

export const saveDeterminationDocument = (id, payload) =>
  api.post(`${URL}/${id}/determination/documents`, payload);

export const deleteDeterminationDocument = (id, documentId) =>
  api.delete(`${URL}/${id}/determination/documents/${documentId}`);

export const getYearsToCurrent = () => api.get(`${URL}/years-to-current`);

export const getContractors = (id) => api.get(`${URL}/${id}/contractors`);
